module.exports = __webpack_public_path__ + "img/arrival-modal-icon.bacf23b8.svg";